'use strict';

angular.module('risevision.rva', [
  'risevision.rva.controllers',
  'risevision.rva.services',
  'risevision.common.header',
  'risevision.common.components.store-products'
])
.value('FORCE_GOOGLE_AUTH', true)
// Set up our mappings between URLs, templates, and controllers
.config(['$urlRouterProvider', '$stateProvider', '$locationProvider',
  function storeRouteConfig($urlRouterProvider, $stateProvider, 
    $locationProvider) {

    $locationProvider.html5Mode(false);
    $locationProvider.hashPrefix('');

    $urlRouterProvider.otherwise('/');

    // Use $stateProvider to configure states.
    $stateProvider.state('rva', {
      url: '?cid',
      params: {
        cid: ''
      },
      abstract: true,
      template: '<div ui-view></div>'
    })

    .state('rva.start', {
      url: '/'
    })

    // editor
    .state('rva.editor', {
      abstract: true
    })

    .state('rva.editor.list', {
      url: '/PRESENTATIONS'
    })

    .state('rva.editor.manage', {
      url: '/PRESENTATION_MANAGE/:id/:fromCompanyId',
      params: {
        id: {
          value: '',
          squash: true
        },
        fromCompanyId: {
          value: '',
          squash: true
        }
      },
      resolve: {
        canAccessApps: ['canAccessApps',
          function (canAccessApps) {
            return canAccessApps();
          }
        ]
      }
    })

    .state('rva.gadgets', {
      abstract: true,
    })
    .state('rva.gadgets.list', {
      url: '/GADGETS',
      resolve: {
        canAccessApps: ['canAccessApps',
          function (canAccessApps) {
            return canAccessApps();
          }
        ]
      }
    })
    .state('rva.gadgets.manage', {
      url: '/GADGET_MANAGE/:id',
      params: {
        id: {
          value: '',
          squash: true
        }
      },
      resolve: {
        canAccessApps: ['canAccessApps',
          function (canAccessApps) {
            return canAccessApps();
          }
        ]
      }
    })

    .state('rva.settings', {
      url: '?cid',
      abstract: true,
    })    
    .state('rva.settings.company', {
      url: '/COMPANY_MANAGE',
      resolve: {
        canAccessApps: ['canAccessApps',
          function (canAccessApps) {
            return canAccessApps();
          }
        ]
      }
    })
    .state('rva.settings.portal', {
      url: '/MANAGE_PORTAL',
      resolve: {
        canAccessApps: ['canAccessApps',
          function (canAccessApps) {
            return canAccessApps();
          }
        ]
      }
    });
  }
])
.run(['$transitions', '$exceptionHandler', 
  function($transitions, $exceptionHandler) {
    $transitions.onError({}, transition => {
      var error = transition.error();

      // angular-ui-router/stateEvents.js:37 - Ignored (and Invalid) transitions are not handled
      // angular-ui-router/stateEvents.js:200 - Superseded and Aborted transitions are not thrown
      if (error && (error.type === 2 /* RejectType.SUPERSEDED */ || error.type === 3 /* RejectType.ABORTED */ || error.type === 5 /* RejectType.IGNORED */)) {
        // 'superseded' type errors caused by 'redirectTo:'
        return;
      }

      $exceptionHandler(error, 'UI Router Error.', true);
    });
  }])
.run(['$window',
  function ($window) {
    if ($window.location.protocol !== 'https:' && $window.location.hostname !== 'localhost') {
      $window.location.replace(`https:${$window.location.href.substring($window.location.protocol.length)}`);
    }
  }
]);

angular.module('risevision.rva.controllers', []);
angular.module('risevision.rva.services', []);
